module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/0@2.png?ccdf04112f727b1eba1e4fe11da6951e";